module.exports = __webpack_public_path__ + "img/Close_Line-16px-dark.27f12f09.svg";